import type { JSX } from 'react'
import { ShieldCheck } from 'lucide-react'
import MfaSection from '../../components/agent/MfaSection.js'

export default function PlatformMfaPage(): JSX.Element {
  return (
    <div className="p-6">
      <div className="mx-auto max-w-3xl space-y-6">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 text-[#3366FF]">
            <ShieldCheck className="h-5 w-5" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-gray-900">Platform Multi-Factor Authentication (MFA)</h1>
            <p className="text-xs text-gray-500">
              Multi-factor authentication is compulsory for platform administrators. Manage your authenticator application keys, regenerate recovery backup codes, or reset your MFA.
            </p>
          </div>
        </div>

        <MfaSection mode="platform" />
      </div>
    </div>
  )
}
